module.exports = __webpack_public_path__ + "07_hige_white.8d3b5648.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/07_hige_white.png
// module id = qup2
// module chunks = 0